import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { LTOPackageItemKeys } from '../../api/Constants';
import { getPlayerProfile } from '../../state/query/player';
import { getLevelUpData } from '../../state/query/levelUp';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { getMissions } from '../../state/query/missions';
import { setLTOOffer } from '../../state/slices/consumables/consumables';
import { store } from '../../state/store';
import Utils from '../../utils';
import TimeStampManager from '../../utils/TimestampManager';
import audio from '../../utils/audio';
import { FE_MISSIONS, FE_EVENTS } from '../../utils/featureFlags/constants';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { ltoCallBackHandler } from '../../utils/function';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import PushNotification from '../notifications/PushNotification';
import { fetchGameRooms } from '../../state/query/games/utils';
import { getEvents } from '../../state/query/events';
import { promoListHandler } from '../../utils/PromotionAction';
import appInitDispatch from './redux/appInitDispatch';
import { EVENT_TYPES } from '../analytics/constants';
import Logger from '../../lib/analytics/logger';
import ERROR_CODE from '../../utils/errorCodes';
import { PLATFORM } from '../../constants';
import { postInitapp } from '../../state/query/app';
function fetchPlayerProfile() {
  return _fetchPlayerProfile.apply(this, arguments);
}
function _fetchPlayerProfile() {
  _fetchPlayerProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return store.dispatch(getPlayerProfile.initiate()).unwrap();
        case 3:
          _context.next = 8;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
            error: JSON.stringify(_context.t0),
            code: ERROR_CODE.GET_PLAYER_PROFILE_ERROR
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _fetchPlayerProfile.apply(this, arguments);
}
function fetchLevelUp() {
  return _fetchLevelUp.apply(this, arguments);
}
function _fetchLevelUp() {
  _fetchLevelUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return store.dispatch(getLevelUpData.initiate()).unwrap();
        case 3:
          _context2.next = 8;
          break;
        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2["catch"](0);
          Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
            error: JSON.stringify(_context2.t0),
            code: ERROR_CODE.LEVEL_UP_ERROR
          });
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 5]]);
  }));
  return _fetchLevelUp.apply(this, arguments);
}
function fetchInitApp(_x) {
  return _fetchInitApp.apply(this, arguments);
}
function _fetchInitApp() {
  _fetchInitApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(init) {
    var initAppRes, _initAppRes$XP, CURRENT_XP, XP_BET_MULTIPLIER, XP_PER_SPIN, XP_TO_NEXT, MAX_LEVEL, LEVEL_META, nextBoostLevel, nextBoostPercentage, nextLevelCoins, ltoResponse, timedBonus;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return store.dispatch(postInitapp.initiate({
            checkPreloadAssets: true
          })).unwrap();
        case 2:
          initAppRes = _context3.sent;
          if (initAppRes.XP) {
            _initAppRes$XP = initAppRes.XP, CURRENT_XP = _initAppRes$XP.CURRENT_XP, XP_BET_MULTIPLIER = _initAppRes$XP.XP_BET_MULTIPLIER, XP_PER_SPIN = _initAppRes$XP.XP_PER_SPIN, XP_TO_NEXT = _initAppRes$XP.XP_TO_NEXT, MAX_LEVEL = _initAppRes$XP.MAX_LEVEL, LEVEL_META = _initAppRes$XP.LEVEL_META;
            nextBoostLevel = LEVEL_META.nextBoostLevel, nextBoostPercentage = LEVEL_META.nextBoostPercentage, nextLevelCoins = LEVEL_META.nextLevelCoins;
            init.setXpData({
              xp: CURRENT_XP,
              xpBetMultiplier: XP_BET_MULTIPLIER,
              xpPerSpin: XP_PER_SPIN,
              xpRequired: XP_TO_NEXT + CURRENT_XP
            });
            init.setLevelData({
              max: MAX_LEVEL - 1,
              nextLevelBonusCoins: nextLevelCoins,
              currentLevelBonusCoins: nextLevelCoins,
              nextBoostLevel: nextBoostLevel,
              nextBoostPercentage: nextBoostPercentage
            });
          }
          init.setCasinoIdStatus(initAppRes.CASINO_ID_STATUS);
          init.setCasinoId(initAppRes.CASINO_ID);
          if (initAppRes.SETTINGS) {
            init.setKYCStatus({
              isKYCDone: initAppRes.SETTINGS.kyocInfo.iskyocdone,
              KYCResult: initAppRes.SETTINGS.kyocInfo.kyocresult,
              KYCInfo: initAppRes.SETTINGS.kyocInfo.info
            });
            init.setSoundSettings({
              soundEffects: initAppRes.SETTINGS.soundEffects,
              music: initAppRes.SETTINGS.music
            });
          }
          if (initAppRes.PROPERTY_INFO) {
            init.setPropertyName(initAppRes.PROPERTY_INFO.propertyName);
          }
          init.setSaleAvailable(initAppRes.SALE);

          // Getting the array of favourite games from init app
          if (initAppRes.FAVOURITE) {
            init.setFavouriteGames(transformObjectArrayResponse(initAppRes.FAVOURITE.FAVOURITE_GAMES));
            init.setOnboardingUnlockLevel(ONBOARDING_FLOWS.FAVOURITES, initAppRes.FAVOURITE.UNLOCK_LEVEL);
          }

          // Set Video Ads Info: remaining videos and time remaining until videos refresh
          if (initAppRes.INVENTORY) {
            init.setVideosAdsInfo({
              remaining: initAppRes.INVENTORY.video,
              secondsUntilReset: initAppRes.WATCH_AND_EARN.seconds_until_reset
            });
          }
          if (initAppRes.LOBBY) {
            init.setLobbyBackgroundPromo(initAppRes.LOBBY.background);
          }
          promoListHandler({
            first_slide: initAppRes.PROMOTIONS,
            second_slide: initAppRes.PROMOTIONS_SECOND,
            third_slide: initAppRes.PROMOTIONS_THIRD
          });

          // Will set the LTO in the store, and refresh as necessary.
          if (initAppRes.LIMITED_TIME_OFFER) {
            ltoResponse = transformObjectResponseKeys(initAppRes.LIMITED_TIME_OFFER, LTOPackageItemKeys);
            ltoResponse.OFFER_END_TIME = ltoResponse.TIME_LEFT_IN_SEC * 1000 + Date.now();
            init.setLTOOffer(ltoResponse);
            TimeStampManager.register(ltoResponse.TIME_LEFT_IN_SEC * 1000, ltoCallBackHandler(store, setLTOOffer));
          }

          // Will refresh active and free consumables
          init.getRefreshActiveConsumables();

          /* #region Timed Bonus */
          if (initAppRes.TIMED_BONUS) {
            timedBonus = _objectSpread(_objectSpread({}, initAppRes.TIMED_BONUS), {}, {
              timeLeft: Date.now() + initAppRes.TIMED_BONUS.timeLeft * 1000
            }); // Usamos la copia en lugar del original
            init.setTimedBonus(timedBonus);
          }
          return _context3.abrupt("return", initAppRes);
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchInitApp.apply(this, arguments);
}
function fetchFeatures() {
  return _fetchFeatures.apply(this, arguments);
}
function _fetchFeatures() {
  _fetchFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _useFeatureFlags, hasFeature, dispatchInitiate;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature;
          dispatchInitiate = /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(feature, action) {
              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!hasFeature(feature)) {
                      _context4.next = 3;
                      break;
                    }
                    _context4.next = 3;
                    return store.dispatch(action.initiate({
                      requestAssetsData: true
                    }, {
                      forceRefetch: true
                    }));
                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            return function dispatchInitiate(_x2, _x3) {
              return _ref.apply(this, arguments);
            };
          }();
          _context5.next = 5;
          return dispatchInitiate(FE_EVENTS, getEvents);
        case 5:
          _context5.next = 7;
          return dispatchInitiate(FE_MISSIONS, getMissions);
        case 7:
          _context5.next = 11;
          break;
        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](0);
        case 11:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 9]]);
  }));
  return _fetchFeatures.apply(this, arguments);
}
export default function initApp() {
  return _initApp.apply(this, arguments);
}
function _initApp() {
  _initApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var init, initAppRes, loadingPromises;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          init = appInitDispatch(store.dispatch);
          init.setIsInitAppExecuting(true);
          _context6.next = 4;
          return fetchInitApp(init);
        case 4:
          initAppRes = _context6.sent;
          loadingPromises = [fetchPlayerProfile(), fetchLevelUp(), fetchGameRooms(true, true)];
          _context6.next = 8;
          return fetchFeatures();
        case 8:
          // Check if the app initialized from a notification
          // Not needed on android as it will run the onNotification handler
          Utils.getPlatform() === PLATFORM.IOS && PushNotification.popInitialNotification();

          // // And then make sure everything finished loading before we show the lobby
          _context6.next = 11;
          return Promise.all(loadingPromises);
        case 11:
          // Schedule miss you push notification if enabled, clear if disabled
          !Utils.isWebOrMobileWeb() && PushNotification.scheduleMissYouNotification();
          init.setIsInitAppExecuting(false);
          init.setLastInitApp(new Date().getTime());
          init.setInitAppResponse(initAppRes);
          audio.pauseSfx();
          audio.playMusic('backgroundMusic', true);
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _initApp.apply(this, arguments);
}